import { useEffect } from 'react';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library

export const FourthSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: 'ease-in-out', // Animation easing
      once: false, // Only animate once
    });
  }, []);

  return (
    <>
      <div className="container mt-4">
        <hr />
        <div className="row">
          <div className="col-md-4" data-aos="fade-up">
            <div className="card mb-3 mt-3" style={{ height: '120px', backgroundColor:'#fe7373' }}>
              <a href="/blogs" style={{textDecoration:"none", color:'white', fontSize:"75px", textAlign:"center"}}>Blogs</a>
            </div>
          </div>
          <div className="col-md-4" data-aos="zoom-in" data-aos-delay="200">
            <div className="card mb-3 mt-3" style={{ height: '120px', backgroundColor:'#fe7373' }}>
            <a href="/quotes" style={{textDecoration:"none", color:'white', fontSize:"75px", textAlign:"center"}}>Quotes</a>
            </div>
          </div>
          <div className="col-md-4" data-aos="slide-right" data-aos-delay="400">
            <div className="card mb-3 mt-3" style={{ height: '120px', backgroundColor:'#fe7373' }}>
            <a href="/poems-eng" style={{textDecoration:"none", color:'white', fontSize:"75px", textAlign:"center"}}>Poems</a>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </>
  );
};
